export default {
  name: 'marking--taskManager',
  apiService: 'shoes',
  apiPath: '/admin/task_manager_model',
};